// src/stores/authStore.js
import { defineStore } from "pinia";
import { authService } from "@/services/authService";
import { useAppStore } from "@/stores/appStore";

// Funções auxiliares para manipulação do localStorage
const setLocalStorage = (token, user) => {
  localStorage.setItem("token", token.split("|")[1]);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("expiresAt", new Date().getTime() + 3600 * 1000);
};

const clearLocalStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("expiresAt");
};

export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
    isAuthenticated: !!localStorage.getItem("token"),
  }),

  actions: {
    async register(params) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await authService.signUp(params);

        this.token = response.data.token;
        this.user = response.data.user;
        this.isAuthenticated = true;

        setLocalStorage(this.token, this.user);
      } catch (error) {
        console.error("Registration failed:", error);
      } finally {
        appStore.setLoading(false);
      }
    },

    async login(params) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await authService.signIn(params);

        this.token = response.data.token;
        this.user = response.data.user;
        this.isAuthenticated = true;

        setLocalStorage(this.token, this.user);

        return response;
      } catch (error) {
        console.error(error.response?.data?.message);
      } finally {
        appStore.setLoading(false);
      }
    },

    async logout() {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        await authService.logout();

        this.token = null;
        this.user = null;
        this.isAuthenticated = false;

        clearLocalStorage();
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        appStore.setLoading(false);
      }
    },

    autoLogin() {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const expiresAt = localStorage.getItem("expiresAt");

      if (token && user && expiresAt) {
        const now = new Date().getTime();
        if (now < expiresAt) {
          this.token = token;
          this.user = user;
          this.isAuthenticated = true;
        } else {
          this.logout();
        }
      }
    },
  },
});
